import { EmptyCell, Icon } from 'shared/ui'
import { type IColumn } from 'shared/ui/TableNew'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { EnumUserRoles, UserAccessRequestType } from 'entities/Users'
import { type RowAccessRequest } from 'entities/Users/model/Table/RowAccessRequest'
import { RoleChip } from 'pages/settings/pages/members/ui/RoleChip/RoleChip'
import { MemberNameCell } from 'pages/settings/pages/members/pages/membersView/ui/MemberNameCell/MemberNameCell'

export const getAccessRequestColumns = (
  type: UserAccessRequestType
): IColumn<RowAccessRequest>[] => {
  const isSalesmsgAccess = type === UserAccessRequestType.SalesmsgAccess

  const nameColumn: IColumn<RowAccessRequest> = {
    field: 'fullName',
    name: 'Name',
    minWidth: '250px',
    width: '100%',
    isSortable: true,
    sortKey: 'full_name',
    renderRowCell: (row) => (
      <MemberNameCell
        avatarInfo={row.avatarInfo}
        fullName={row.fullName}
        email={row.email}
        online={!row.isAway}
      />
    ),
  }

  const roleColumn: IColumn<RowAccessRequest> = {
    field: 'roleLabel',
    name: 'Role',
    maxWidth: '100px',
    isSortable: true,
    sortKey: 'role',
    renderRowCell: (row) =>
      row.roleLabel ? (
        <RoleChip roleLabel={row.roleLabel} hasCustomPermissions={row.hasCustomPermissions} />
      ) : (
        <EmptyCell />
      ),
  }

  const seatColumn: IColumn<RowAccessRequest> = {
    field: 'seat',
    name: 'Seat',
    maxWidth: '60px',
    renderRowCell: (row) =>
      row.role && row.role !== EnumUserRoles.VIEW_ONLY ? (
        <Icon icon='check1' color='var(--content-brand-primary)' />
      ) : (
        <EmptyCell />
      ),
  }

  const requestDateColumn: IColumn<RowAccessRequest> = {
    field: 'createdAt',
    name: 'Request date',
    maxWidth: '150px',
    isSortable: true,
    sortKey: 'created_at',
    renderRowCell: (row) =>
      row.createdAt &&
      `${uiStore.dayjs(row.createdAt).format(DayjsFormats.full6)}${
        row.requestOn ? ` (${row.requestOn})` : ''
      }`,
  }

  if (isSalesmsgAccess) {
    return [nameColumn, requestDateColumn]
  }

  return [nameColumn, roleColumn, seatColumn, requestDateColumn]
}
